import React, { useContext, useEffect, useState, useRef } from 'react';
import Partydetail from '../Partydetail';
import { ButtonHeading, CommonDateRange } from 'components';
import { constant } from 'constants/constant';
import Tab from 'components/common/Tab';
import Lorryreceipt from '../Lorryreceipt';
import Invoice from '../Invoice';
import Ledger from '../Ledger';
import Contract from './Contract';
import Rate from '../Rate';
import Settings from '../Settings';
import { Unit } from '../Unit';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import StorageService from 'utils/StorageServices/StorageServices';
import { UserContext } from 'context';
import { fetchConsignorDetailsData } from '_services/accountsServices/consignorServices';
import LoadingBar from 'react-top-loading-bar';
import OtherSetting from '../OtherSetting';
import Location from '../Location';
import Lr from 'pages/Lr';
import toast from 'react-hot-toast';
import { utils } from 'helper';
import moment from 'moment';
import { AdjustBalanceModal, ConfirmModalFor, PartyLrReport, SupplierReport } from 'modals';

const ConsignorDetails = () => {
    const location = useLocation();
    const loadingBarRef = useRef(null);
    const navigate = useNavigate();
    const queryParams = new URLSearchParams(location.search);
    const tabFromQuery = parseInt(queryParams.get('tab'));
    const [activeTab, setActiveTab] = useState(tabFromQuery);
    let { id } = useParams();
    const { masterData, cities, setMasterDetailsList } = useContext(UserContext);
    let company_id = StorageService.getCompanyId();
    const [detailsData, setDetailsData] = useState({})
    const [ledgerDetails, setLedgerDetails] = useState({});

    const [openDate, setOpenDate] = useState(false);
    const [openLedgerModal, setOpenLedgerModal] = useState(false);
    const [openForDownLoad, setOpenForDownLoad] = useState(false);
    const [selectedRange, setSelectedRange] = useState({
        startDate: moment().startOf('month'),
        endDate: moment().endOf('month'),
    });
    const [refreshLedger, setRefreshLedger] = useState(false);

    const [consignorDetailsTabs, setConsignorDetailsTabs] = useState(constant.consignorBaseTabs);

    const consignorTabs = detailsData?.company?.subscription_data?.company_settings?.find((el) => el?.sort === 5)?.permissions ?? [];

    const getConsignorTabs = (baseTabs, perms) => {
        return baseTabs
            .filter((tab) => {
                const perm = perms.find((el) => el?.name === tab.title);
                return !(perm && perm.not_available === 1);
            })
            .map((tab) => {
                const perm = perms.find((el) => el?.name === tab.title);
                if (!perm) return tab;

                const statusKey = [
                    "available",
                    "not_available",
                    "premium",
                    "coming_soon",
                    "full_access",
                ].find((k) => perm[k] === 1);

                return {
                    ...tab,
                    ...(statusKey ? { key: statusKey } : {}),
                    disabled: perm.web !== 1,
                };
            });
    };

    useEffect(() => {
        setConsignorDetailsTabs(getConsignorTabs(constant.consignorBaseTabs, consignorTabs));
    }, [consignorTabs]);

    const getDataConsignorDetails = async (id_1, id_2) => {
        try {
            if (loadingBarRef.current) {
                loadingBarRef.current.continuousStart(); // Start the loading bar
            }
            let object = {
                consignor_id: id_1,
                company_id: id_2,
            };
            const res = await fetchConsignorDetailsData(object);
            if (res?.responseCode == 200) {
                setDetailsData(res?.data);
            }
        } catch (error) {
            if (error?.response?.data?.responseCode === 500) {
                toast.error('Invalid Company & Consignor');
                navigate('/account/consignor');
            }
        } finally {
            if (loadingBarRef.current) {
                loadingBarRef.current.complete(); // Complete the loading bar
            }
        }
    };

    useEffect(() => {
        if (id && company_id) {
            getDataConsignorDetails(id, company_id);
        }
    }, [id]);

    useEffect(() => {
        setActiveTab(tabFromQuery);
    }, [tabFromQuery]);

    const handleActiveTabs = (e) => {
        setActiveTab(e);

        const params = new URLSearchParams(location.search);
        params.set('tab', e);
        navigate(`${location.pathname}?${params.toString()}`);
    }

    const tabProps = {
        tabList: consignorDetailsTabs,
        callBackTab: (e) => handleActiveTabs(e),
        activeTab: activeTab,
        keyStatusInsideTabs: true,
    };

    const handleApply = (newRange) => {
        setSelectedRange(newRange);
    };

    const OpenModalForDownload = () => {
        setOpenDate(false);
        setOpenForDownLoad(true)
    }


    const calback = () => {

        setOpenLedgerModal(false)
        setRefreshLedger(prev => !prev);
    }

    let confirmModalProps = {
        show: openDate,
        closeModal: (e) => setOpenDate(false),
        title: "Date Range",
        submitTitle: "Submit",
        onSubmit: OpenModalForDownload,
        confirmModal: "confirmModal",
    };

    let partyLrReportModalProps = {
        isOpen: openForDownLoad,
        closeModal: (e) => setOpenForDownLoad(false),
        modalMainClass: "_dashCommon_Modal _printViewModal _xxlModal",
        footerPart: true,
        modalTitle: "Party LR Report",
        submitTitle: "Download",
        therdSubmitTitle: "Download",
        consignor_id: detailsData?.consignor?._id,
        start_date: moment(selectedRange?.startDate).format("YYYY-MM-DD"),
        end_date: moment(selectedRange?.endDate).format("YYYY-MM-DD"),
    }

    let LedgerAdjustModalProps = {
        isOpen: openLedgerModal,
        closeModal: (e) => setOpenLedgerModal(false),
        modalMainClass: "_dashCommon_Modal _prtThemeModal _smModal",
        footerPart: false,
        approvalBtn: true,
        approvalBtnTxt: 'Send for Approval',
        modalTitle: "Adjust Balance",
        submitTitle: "Adjust Balance",
        detailsData: ledgerDetails,
        venderType: "Consignor",

        calback: calback
    }

    return (
        <div className="__cmnDetailBx_inrBxs">
            <LoadingBar
                color="#ffa800"
                ref={loadingBarRef}
                height={4}
                shadow={true}
                loaderSpeed={1000}
            />
            <ButtonHeading
                title={detailsData?.consignor?.name}
                buttonTitle="Back"
                isBackButton={true}
                onClickBackButton={() => { navigate('/account/consignor'); setMasterDetailsList({}) }} // navigate(-1)
                printButtonTitle={activeTab == 2 ? "Party LR Report" : ""}
                printOnClick={() => setOpenDate(true)}
                ledgerButtonTitle={activeTab == 4 ? "Adjust Balance" : ""}
                ledgerOnClick={() => setOpenLedgerModal(true)}
            />

            <div className="addPr_flBx commonDetails_bxs">
                <Tab {...tabProps} />
                {activeTab === 1 && <Partydetail detailsData={detailsData?.consignor} masterData={masterData} />}
                {activeTab === 2 && <Lr hideHeaderSection={false} detailsData={detailsData?.consignor} />}
                {activeTab === 3 && <Invoice />}
                {activeTab === 4 && <Ledger type={2} refresh={refreshLedger} setLedgerDetails={setLedgerDetails} />}
                {activeTab === 5 && <Unit handleScrollClass="partyTabs_cls" isConsignor={id} isFilterButton={false} firmId={detailsData?.consignor?.firm_id} />}
                {activeTab === 6 && <Contract />}
                {activeTab === 7 && <Rate />}
                {activeTab === 8 && <Settings detailsData={detailsData} />}
                {activeTab === 9 && <OtherSetting details={detailsData} />}
                {activeTab === 10 && <Location details={detailsData} />}
                {/* {activeTab === 11 && (
                    <Lr/>
                )} */}
            </div>

            {openDate && (
                <ConfirmModalFor {...confirmModalProps}>
                    <>
                        <div className="_divForth">
                            <CommonDateRange
                                initialStartDate={selectedRange.startDate}
                                initialEndDate={selectedRange.endDate}
                                onApply={handleApply}
                            />
                        </div>
                    </>
                </ConfirmModalFor>
            )}

            {openForDownLoad && <PartyLrReport {...partyLrReportModalProps} />}
            {openLedgerModal && <AdjustBalanceModal {...LedgerAdjustModalProps} />}
        </div>
    );
};

export default React.memo(ConsignorDetails)
